import { render, staticRenderFns } from "./AccountsTemplate.vue?vue&type=template&id=ae5d2060&scoped=true&"
import script from "./AccountsTemplate.vue?vue&type=script&lang=js&"
export * from "./AccountsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AccountsTemplate.vue?vue&type=style&index=0&id=ae5d2060&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5d2060",
  null
  
)

export default component.exports